import MessageBaseController from '../common/message.base.controller'

class MessageallController extends MessageBaseController {
  /*@ngInject*/
  constructor(Auth, $state, $stateParams, User, UserService, MessageService, $translate, Modal, $location) {

    super(Auth, $state, User, MessageService, Modal, $translate, $stateParams, $location);
    this.message = 'Message all'

    this.hasAcl = {}

    this.page = 1;
    this.total = 0;
    this.pageLimit = 10;
    this.maxPages = 10;
    this.searchText = null;
    this.$location = $location;
    this.loggedInUser = this.User.getUser();
    this.Modal = Modal;
    this.msgsOf = 'all';
    this.messages = [];
    this.duplicateMsgs = [];
    this.pendingMegs = []

    this.types = ['M', 'T', 'R', 'SM', 'NP', 'UI', 'H', 'D_R', 'CNT', 'D_CNT', 'NDR', 'IM','DS'];
    this.messageType = null;
    this.messageTypes = this.types.map((messageType) => {
      return {
        value: messageType,
        label: $translate.instant('message.types.' + messageType)
      };
    });
    this.branchId = this.User.getUser().branchId;
    this.model = {
      searchText: null,
      languageId: null,
      loadBuckets: false,
      errorMessage: null,
      buckets: [],
      languageList: {
        english: 'E',
        spanish: 'S'
      },
      stats: 'E',
      messageTypeList: {},
      bucketList: {
        'M': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'T': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'R': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'SM': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'NP': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'UI': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'H': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'D_R': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'CNT': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'D_CNT': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'NDR': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'IM': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'DS': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        }
      }
    };
    this.stats = {
      english: 'E',
      spanish: 'S'
    }
    this.model.selectedLanguage = this.loggedInUser.languageId === "E" ? this.model.languageList.english : this.model.languageList.spanish;
  }

  $onInit() {
    this.loadData();
  }

  delete(messagesObj, bucketObj) {
    if (this.allowOnlyOnce) return;
    this.allowOnlyOnce = true;
    let lang = messagesObj.languageName;
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${messagesObj.messageId}</strong>?`,
      callback: ({
        modal,
        $scope
      }) => {
        $scope.loading = true;
        let langId = messagesObj.languageId;
        this.Service.remove(langId, messagesObj.id, messagesObj.messageId, messagesObj.type, this.branchId)
          .then((data) => {
            this.allowOnlyOnce = false;
            modal.close();
            this.searchLanguageMessages(bucketObj).then(() => {
              let buckets = _.find(this.model.buckets.results, { 'messageType': messagesObj.type });
              buckets.total = this.model.bucketList[bucketObj.messageType].totalRecords;
            });
          })
      },
      negative: (({
        modal,
      }) => {
        this.allowOnlyOnce = false;
        modal.close();
      }),
      type: 'danger'
    })
  }

  tabSelection(selectedValue) {
    this.model.stats = selectedValue;
    this.model.selectedLanguage = selectedValue;
    const id = (selectedValue === 'english') ? 'english' : 'spanish';
    document.getElementById(id).blur();
    this.loadData();
  }

  getMessageTypeBuckets() {
    this.model.loadBuckets = true;
    this.Service.getMessageTypeBuckets(this.model.serchText, this.model.selectedLanguage)
      .then((data) => {
        this.model.buckets = data;
      })
      .catch((err) => {
        this.model.errorMessage = err.data.message;
      })
      .finally(() => {
        this.model.loadBuckets = false;
      })
  }

  loadData() {
    this.resetSeachText();
    this.getMessageTypeBuckets();
  }

  translateMessageType(messageType) {
    if (!messageType) return;
    return this.$translate.instant(`message.types.${messageType}`);
  }

  setPage(isExpanded, messageType) {
    if (!isExpanded) return;
    this.model.messageTypeList[messageType] = { page: 1 };
  }

  getLanguageMessages(obj) {
    if (!obj.bucketExpanded) {
      this.model.bucketList[obj.messageType].searchKey = null;
      return;
    }

    this.model.bucketList[obj.messageType].loading = true;

    return this.Service.getLanguageMessages(this.model.bucketList[obj.messageType].searchKey, this.model.selectedLanguage, obj.messageType,
      this.model.bucketList[obj.messageType].pagination.pageLimit,
      (this.model.messageTypeList[obj.messageType].page - 1) * this.model.bucketList[obj.messageType].pagination.pageLimit)
      .then((data) => {
        this.model.bucketList[obj.messageType].results = data.results;
        this.model.bucketList[obj.messageType].totalRecords = data.total;
      })
      .catch((err) => {
        this.model.bucketList[obj.messageType].errorMessage = err.data.message;
      })
      .finally(() => {
        this.model.bucketList[obj.messageType].loading = false;
        setTimeout(() => {
          const el = document.getElementById(obj.messageType + '-bucketSearch');
          if (el) el.focus();
        }, 100);
      })
  }

  searchLanguageMessages(obj) {
    this.model.messageTypeList[obj.messageType].page = 1;
    return this.getLanguageMessages(obj);
  }

  pageChange(obj) {
    this.getLanguageMessages(obj);
  }

  resetSeachText() {
    this.types.forEach(messageType => messageType && this.model.bucketList[messageType] ? this.model.bucketList[messageType].searchKey = null: void undefined);
  }

  updateLanguageMessageModal(messagesObj, bucketObj) {
    this.Modal.translateMessage(messagesObj.messageId, messagesObj.type, ({ updatedMessages, modal }) => {
      this.Service.updateLanguageMessage(messagesObj.languageId, updatedMessages)
        .then(() => {
          this.getLanguageMessages(bucketObj);
          modal.close();
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            errorModal(err.data.message);
          }
        })
      modal.close();
    }, ({ modal }) => {
      if (modal) modal.close();
    })
  }

  createLanguageMessage(bucketObj) {
    this.Modal.createLanguageMessage(bucketObj, this.messageTypes, this.model.selectedLanguage, bucketObj.messageType, ({ modal}) => {
      let buckets = _.find(this.model.buckets.results, { 'messageType': bucketObj.messageType });
      if (bucketObj.bucketExpanded) {
        this.getLanguageMessages(bucketObj).then(() => {
          buckets.total = this.model.bucketList[bucketObj.messageType].totalRecords;
          modal.close();
        })
      }
      else {
        buckets.total = buckets.total + 1;
        modal.close();
      }
    }, ({ modal }) => {
      if (modal) modal.close();
    })
  }

}

export default MessageallController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/all/message.all.controller.js